import { isLensProductType } from './vaInvoiceUtils';

export function getOrderLines(row, allItems = []) {
  if (!row) return [];
  const shopifyId = String(row.ShopifyId ?? '').trim();
  const backerId = String(row.BackerID ?? '').trim();
  const lines = allItems.filter(item =>
    shopifyId ? String(item.ShopifyId ?? '') === shopifyId
      : backerId && String(item.BackerID ?? '') === backerId
  );
  return lines.length ? lines : [row];
}

function isLiveLine(item) {
  return item && !item.softDeleted && !item.isRemoved && !item.isReturned;
}

// Older APIs may return a removed lens as the representative of a live order.
export function resolveOrderSelectionRow(row, allItems = []) {
  if (!row) return row;
  const live = getOrderLines(row, allItems).filter(isLiveLine);
  if (!live.length) return row;
  const valid = live.filter(item => Number(item.Status) !== 999);
  const lenses = valid.filter(item => isLensProductType(item.ProductType));
  const candidates = lenses.length ? lenses : valid;
  const chosen = candidates.length
    ? candidates.reduce((min, item) => Number(item.Status) < Number(min.Status) ? item : min)
    : live[0];
  const resolved = { ...row };
  for (const field of ['ItemID', 'ShopifyItemID', 'Status', 'ProductType', 'isRemoved', 'isReturned', 'softDeleted', 'Redo']) {
    resolved[field] = chosen[field];
  }
  return resolved;
}

export function isOrderRowSelectable(row, allItems = [], canSoftDelete = false) {
  if (!row || !getOrderLines(row, allItems).some(isLiveLine)) return false;
  const resolved = resolveOrderSelectionRow(row, allItems);
  return Number(resolved.Status) === 999 ? Boolean(canSoftDelete) : true;
}
